import React from 'react';
import { AvatarRectangle, Chip, Subtitle } from '@/components/atoms';
import { Wrapper, RightArea, TextArea } from './CreditListItem.styled';
import { ICardItem } from '@/types';

const CreditListItem = (props: ICardItem) => {
  const { supportText, cardName, desc1, cardImagePath, onClick } = props;


  return (
    <Wrapper onClick={onClick}>
      <AvatarRectangle src={cardImagePath} alt={cardName} />
      <RightArea>
        <TextArea>
          <Subtitle level={4} color="gray-800" whiteSpaceWrap>
            {desc1}
          </Subtitle>
          <Subtitle level={6} whiteSpaceWrap>
            {cardName}
          </Subtitle>
        </TextArea>
        {supportText && <Chip>{supportText}</Chip>}
      </RightArea>
    </Wrapper>
  );
};

export default React.memo(CreditListItem);
